import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import {Section} from '@primer/react-brand/esm'
import type {SetupSectionContent} from '../../content'
import {Cards} from '../../_components/Cards/Cards'

type Props = {
  contentfulContent: SetupSectionContent
}

export function SetupSection({contentfulContent}: Props) {
  const sectionId = contentfulContent.section.fields.htmlId
  const sectionIntro = contentfulContent.sectionIntro
  const cards = contentfulContent.cards

  return (
    <Section id={sectionId} fullWidth paddingBlockEnd="none">
      {sectionIntro ? <ContentfulSectionIntro component={sectionIntro} /> : null}

      {cards ? <Cards component={cards} /> : null}
    </Section>
  )
}
